import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { AutocompleteItem, Group, Stack, Text, ThemeIcon, Tooltip } from '@mantine/core';
import { IconCheck } from '@tabler/icons-react';

import { BVScheduledFlight } from '@/modules/common/model';

export interface FlightAutocompleteItem extends AutocompleteItem {
  flight: BVScheduledFlight;
}

const extractTime = (datetime: string): string => {
  const match = datetime.match(/(\d{2}:\d{2})/);
  return match ? match[1] : datetime;
};

export const FlightDropdownItem = forwardRef<HTMLDivElement, FlightAutocompleteItem>(({ flight, ...others }, ref) => {
  const { t } = useTranslation();

  return (
    <div ref={ref} {...others}>
      <Group position="apart" noWrap>
        <Group grow sx={{ flex: 1 }}>
          <Stack spacing={2}>
            <Text fw="bold" fz="sm">
              {flight.number}
            </Text>
            <Text fz="xs" c="dimmed">
              {flight.carrier.name}
            </Text>
          </Stack>
          <Stack spacing={2}>
            <Text fz="sm">{`${flight.departureAirport.city} (${flight.departureAirport.code})`}</Text>
            <Text fz="xs" c="dimmed">
              {extractTime(flight.departureTime)}
            </Text>
          </Stack>
          <Stack spacing={2}>
            <Text fz="sm">{`${flight.arrivalAirport.city} (${flight.arrivalAirport.code})`}</Text>
            <Text fz="xs" c="dimmed">
              {extractTime(flight.arrivalTime)}
            </Text>
          </Stack>
        </Group>
        <Tooltip label={t('booking-flight_validate_tooltip')} zIndex={99999} withinPortal>
          <ThemeIcon color="green" variant="outline" radius="xl" size="sm">
            <IconCheck />
          </ThemeIcon>
        </Tooltip>
      </Group>
    </div>
  );
});
